import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { ProcedureName98 } from "../../assets/data/Constants";
import { GlobalContext } from "../../context/globalContext";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkLabelText from "../../components/atoms/TkLabelText";
import TkButton from "../../components/atoms/TkButton";
import { IAPI_AGE007_Response, IAPI_AGE009_Request } from "../../type/apiType";
import { httpIAPI_AGE007, httpIAPI_AGE009 } from "./api/request";
import { fakeTableList, schema } from "./parts";
import "./_style.scss";
import _ from "lodash";
import { labelids } from "../../assets/data/TkExplanationProperty";

/**
 * SCRC100006 代行者への再依頼
 * @returns JSX.Element
 */
const SCRC100006 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [SCRC100006Data, setSCRC100006Data] = useState<IAPI_AGE007_Response>(
    {}
  );

  // 初期表示
  const handleInit = async () => {
    try {
      const res = await httpIAPI_AGE007({
        taskId: location.state?.taskId,
      });

      if (res.resultCd === "I0000") {
        let resArr = stateFakeTableList.current;

        // 説明文
        let info = resArr.find((item) => item.keyword === "info")!;
        info.explanatoryText =
          location?.state?.requisitionProcess === "1"
            ? labelids.labelid.LBLC100006_01
            : labelids.labelid.LBLC100006_02;

        // 代行者
        let agentUserName = resArr.find(
          (item) => item.keyword === "agentUserName"
        )!;
        agentUserName.selectPropsList = [
          {
            label: res.name,
            value: res.userId,
          },
        ];
        agentUserName.setDefaultValue = res.userId;

        // 代行内容
        resArr.find(
          (item) => item.keyword === "agentContent"
        )!.setDefaultValue = res.formerTaskType;

        // 対象施設
        let agentFacilityName = resArr.find(
          (item) => item.keyword === "agentFacilityName"
        )!;
        agentFacilityName.selectPropsList = [
          {
            label: res.facilityName,
            value: res.facilityNo,
          },
        ];
        agentFacilityName.setDefaultValue = res.facilityNo;
        agentFacilityName.showLine =
          res.formerTaskType !== ProcedureName98["退職届"];

        // 退職者名
        let retirementStaffName = resArr.find(
          (item) => item.keyword === "retirementStaffName"
        )!;
        retirementStaffName.node = (
          <Box className="retirementStaffName">
            <TkLabelText
              wantToSetValue={(res.staffNo ?? "") + ":" + (res.staffName ?? "")}
              disabled
            />
            <TkButton>退職者検索</TkButton>
          </Box>
        );
        retirementStaffName.showLine =
          res.formerTaskType === ProcedureName98["退職届"];

        // タイトル
        let requestTitle = resArr.find(
          (item) => item.keyword === "requestTitle"
        )!;
        requestTitle.setDefaultValue = res.taskTitle;
        requestTitle.disabled =
          location?.state?.requisitionProcess === "1" ? true : false;

        // 対応期日
        let dueDate = resArr.find((item) => item.keyword === "dueDate")!;
        dueDate.setDefaultValue = res.dueDate;
        dueDate.disabled =
          location?.state?.requisitionProcess === "1" ? true : false;

        // 本文
        let requestContent = resArr.find(
          (item) => item.keyword === "requestContent"
        )!;
        requestContent.setDefaultValue = res.taskText;
        requestContent.disabled =
          location?.state?.requisitionProcess === "1" ? true : false;

        setStatecorpInfoList(resArr);

        setSCRC100006Data(res);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (data: any, index: any) => {
    const paramData: IAPI_AGE009_Request = {
      taskId:
        location?.state?.requisitionProcess === "1"
          ? location.state?.taskId
          : null,
      formerTaskId: SCRC100006Data.formerTaskId,
      userId: SCRC100006Data.userId,
      facilityNo: SCRC100006Data.facilityNo,
      formerTaskType: SCRC100006Data.formerTaskType,
      taskTitle: data.requestTitle,
      taskText: data.requestContent,
      dueDate: data.dueDate,
      staffNo:
        data.agentContent === ProcedureName98["退職届"]
          ? SCRC100006Data.staffNo
          : undefined,
    };

    // 代行入力依頼更新API 呼び出し
    try {
      const res = await httpIAPI_AGE009({
        ...paramData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC100001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC100006" data-testid="SCRC100006PageForTest">
      <TkFakeTable
        showButton={false}
        list={statecorpInfoList}
        ruleSchema={schema}
        buttonGroup={<TkBackButton></TkBackButton>}
        submitButtonGroup={[
          {
            submitButtonText:
              location?.state?.requisitionProcess === "1"
                ? "代行者に再依頼"
                : "代行者に依頼",
          },
        ]}
        onCheckAndSubmit={(e, index) => handleSubmit(e, index)}
      />
    </Box>
  );
};

export default SCRC100006;
